import { styled } from '@mui/material/styles';
import MDBox from 'components/MDBox';
import MDInput from 'components/MDInput';


// Material Dashboard 2 PRO React Helper Functions
import pxToRem from 'assets/theme/functions/pxToRem';

export const FormControlWrapperBox = styled(MDBox)`
  margin: ${(props) => `0 ${props.theme.palette.spacing[1] * 2}px`};
`;

export const AttendanceSelect = styled(MDInput)`
  & .MuiSelect-select.MuiOutlinedInput-input {
    height: ${pxToRem(20)};
  }
`;